import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { formatApiError } from '../lib/api';

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithGoogleSession } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }
    loginWithGoogleSession(sessionId)
      .then((result) => {
        window.history.replaceState(null, '', location.pathname);
        if (!result?.mfa_required) navigate('/medlem', { replace: true });
      })
      .catch((e) => setError(formatApiError(e, 'Google-innlogginga feila.')));
  }, [location, navigate, loginWithGoogleSession]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center text-white" data-testid="auth-callback">
      {error ? (
        <div className="text-center space-y-4">
          <p className="text-red-300" data-testid="auth-callback-error">{error}</p>
          <button onClick={() => navigate('/login')} className="px-6 py-3 rounded-full bg-[#ff2e2e] text-black font-bold">Til innlogging</button>
        </div>
      ) : (
        <p className="text-white/60">Loggar deg inn…</p>
      )}
    </div>
  );
};

export default AuthCallback;
